import { render } from "./LoadingDot.vue?vue&type=template&id=22c406b2&scoped=true"
import script from "./LoadingDot.vue?vue&type=script&lang=js"
export * from "./LoadingDot.vue?vue&type=script&lang=js"

import "./LoadingDot.vue?vue&type=style&index=0&id=22c406b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c406b2"]])

export default __exports__